import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {Button} from 'react-bootstrap';
import {apiRoutes, post, get} from '../../../api/api';
import {bindActionCreators} from "redux";

class Contactmailform extends React.Component {

  constructor(props) {
    super(props);
    this.language = props.intl.locale;
    console.log("Binnen Contactmailform");
  }

  sendMail() {
    let naamWaarde = document.getElementById("edit-field-naam-0-value").value;
    let emailWaarde = document.getElementById("edit-field-email-0-value").value;
    let onderwerpWaarde = document.getElementById("edit-field-onderwerp-0-value").value;
    let boodschapWaarde = document.getElementById("edit-field-boodschap-0-value").value;
    let mailInhoud = {
      reallysend: 1,
      name:  naamWaarde,
      email: emailWaarde,
      subject: onderwerpWaarde,
      message: boodschapWaarde
    };
    post(apiRoutes.sendcontactmail.post(), mailInhoud, function (response) {
      document.getElementById("edit-field-naam-0-value").value = "";
      document.getElementById("edit-field-email-0-value").value = "";
      document.getElementById("edit-field-onderwerp-0-value").value = "";
      document.getElementById("edit-field-boodschap-0-value").value = "";
      return "response.data[0]";
    }).then();

  }

  previewMail() {
    let naamWaarde = document.getElementById("edit-field-naam-0-value").value;
    let emailWaarde = document.getElementById("edit-field-email-0-value").value;
    let onderwerpWaarde = document.getElementById("edit-field-onderwerp-0-value").value;
    let boodschapWaarde = document.getElementById("edit-field-boodschap-0-value").value;
    let mailInhoud = {
      reallysend: 0,
      name:  naamWaarde,
      email: emailWaarde,
      subject: onderwerpWaarde,
      message: boodschapWaarde
    };
    post(apiRoutes.sendcontactmail.post(), mailInhoud, function (response) {
      var newWindow = window.open();
      newWindow.document.write(response);
      return "response.data[0]";
    }).then();

  }

  render() {
    return (<div>
        <div className="region region-content">
          <section id="block-contactdatabankinstitutioneleaangelegenheden"
                   className="block block-block-content block-block-content9fdee6ca-000e-48eb-b14d-108c7ce22516 clearfix">

            <h2 className="block-title">Contact SenLex</h2>


            <div className="field field--name-body field--type-text-with-summary field--label-hidden field--item">
              <p><FormattedMessage id="anyQuestions"/></p>

              <p><FormattedMessage id="weWillAnswer"/></p></div>

          </section>
          <form className="contact-message-test-contact-form-form contact-message-form contact-form"
                data-user-info-from-browser="" data-drupal-selector="contact-message-test-contact-form-form"
                action="/nl/contact" method="post" id="contact-message-test-contact-form-form" acceptCharset="UTF-8"
                data-drupal-form-fields="edit-field-naam-0-value,form-l-pUweMbETy5NJtnJzBsXSuEcSAdQXJ24XTHqMy6ilQ,edit-contact-message-test-contact-form-form,edit-field-email-0-value,edit-field-onderwerp-0-value,edit-field-boodschap-0-value,edit-submit,edit-preview">
            <div
              className="field--type-string field--name-field-naam field--widget-string-textfield form-group js-form-wrapper form-wrapper"
              data-drupal-selector="edit-field-naam-wrapper" id="edit-field-naam-wrapper">
              <div
                className="form-item js-form-item form-type-textfield js-form-type-textfield form-item-field-naam-0-value js-form-item-field-naam-0-value form-group">
                <label htmlFor="edit-field-naam-0-value" className="control-label"><FormattedMessage id="Name"/></label>

                <input className="js-text-full text-full form-text form-control"
                       data-drupal-selector="edit-field-naam-0-value" type="text" id="edit-field-naam-0-value"
                       name="field_naam[0][value]" size="60" maxLength="255" placeholder="" title=""
                       data-toggle="tooltip"/>
              </div>
            </div>

            <div
              className="field--type-email field--name-field-email field--widget-email-default form-group js-form-wrapper form-wrapper"
              data-drupal-selector="edit-field-email-wrapper" id="edit-field-email-wrapper">
              <div
                className="form-item js-form-item form-type-email js-form-type-email form-item-field-email-0-value js-form-item-field-email-0-value form-group">
                <label htmlFor="edit-field-email-0-value" className="control-label"><FormattedMessage id="Email"/></label>
                <input data-drupal-selector="edit-field-email-0-value" className="form-email form-control" type="email"
                       id="edit-field-email-0-value" name="field_email[0][value]" size="60" maxLength="254"
                       placeholder="" title="" data-toggle="tooltip"/>
              </div>
            </div>

            <div
              className="field--type-string field--name-field-onderwerp field--widget-string-textfield form-group js-form-wrapper form-wrapper"
              data-drupal-selector="edit-field-onderwerp-wrapper" id="edit-field-onderwerp-wrapper">
              <div
                className="form-item js-form-item form-type-textfield js-form-type-textfield form-item-field-onderwerp-0-value js-form-item-field-onderwerp-0-value form-group">
                <label htmlFor="edit-field-onderwerp-0-value" className="control-label"><FormattedMessage id="Subject"/></label>
                <input className="js-text-full text-full form-text form-control"
                       data-drupal-selector="edit-field-onderwerp-0-value" type="text" id="edit-field-onderwerp-0-value"
                       name="field_onderwerp[0][value]" size="60" maxLength="60" placeholder="" title=""
                       data-toggle="tooltip"/>
              </div>
            </div>

            <div
              className="field--type-string-long field--name-field-boodschap field--widget-string-textarea form-group js-form-wrapper form-wrapper"
              data-drupal-selector="edit-field-boodschap-wrapper" id="edit-field-boodschap-wrapper">
              <div
                className="form-item js-form-item form-type-textarea js-form-type-textarea form-item-field-boodschap-0-value js-form-item-field-boodschap-0-value">
                <label htmlFor="edit-field-boodschap-0-value"
                       className="control-label js-form-required form-required"><FormattedMessage id="Message"/></label>
                <div className="form-textarea-wrapper">
                  <textarea className="js-text-full text-full form-textarea required form-control resize-vertical"
                            data-drupal-selector="edit-field-boodschap-0-value" title="" data-toggle="tooltip"
                            id="edit-field-boodschap-0-value" name="field_boodschap[0][value]" rows="5" cols="60"
                            placeholder="" required="required" aria-required="true"></textarea>
                </div>
              </div>
            </div>
            <div data-drupal-selector="edit-actions" className="form-actions form-group js-form-wrapper form-wrapper"
                 id="edit-actions">
              <Button data-drupal-selector="edit-submit"
                      className="button button--primary js-form-submit form-submit btn-primary btn" onClick={this.sendMail}
                      id="edit-submit" name="op" value="Send message"><FormattedMessage id={"send message"}/>
              </Button>
              <Button data-drupal-selector="edit-preview" className="button js-form-submit form-submit btn-default btn"
                      onClick={this.previewMail}
                      id="edit-preview" name="op" value="Preview"><FormattedMessage id={"show message"}/>
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }


}




function mapStateToProps(state) {
  const {intl, counter} = state;
  console.log("Contactmailform: Binnen mapStateToProps");
  return {
    intl  };
}

function donothing (dispatch) {
  return "";
}

function mapDispatchToProps(dispatch) {
  console.log("Contactmailform: Binnen mapDispatchToProps")
  return {
    donothing: bindActionCreators(donothing, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Contactmailform);





/** WEBPACK FOOTER **
 ** ./src/modules/contactmail/containers/contactmailform.js
 **/